export class PFSources {
    static isRegional(sourceName: string) {
        let name = sourceName.toLowerCase().trim();
        return name.includes(',') && !name.includes('pathfinder #');
    }
}